// @ vendor
const Immutable = require('immutable');

// @ constants
const { DOCUMENT_TYPES } = require('../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_REQUEST_LOAD_DOCUMENTS_FOR_PREVIEW,
    INSURANCE_REQUEST_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_WIZARD_SET_DATA,
    INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP,
    INSURANCE_REQUEST_GET_DOCUMENT_REQUEST,
    INSURANCE_REQUEST_GET_DOCUMENT_SUCCESS,
    INSURANCE_REQUEST_GET_DOCUMENT_FAILURE,
    INSURANCE_REQUEST_DOCUMENT_READ,
    SHOW_PRINT_REQUIRED,
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => {
    const documents = Object.keys(DOCUMENT_TYPES).map(() => {
        return {
            isFetching: false,
            error: ''
        }
    });

    return Immutable.Map().merge({
        acceptedConditions: __CONTACT_CENTER__,
        documents,
        fieldErrors: false,
        isFetchingForPreview: false,
        documentRead: false,
        summary: {
            base64string: '',
            base64: null,
            contentType: '',
        },
        valid: false,
        validUI: false,
    });
};

const validateStep = step => {
    const acceptedConditions = step.get('acceptedConditions');
    const agreementChecked = step.get('agreementChecked');

    return step.merge({
        valid: true,
        validUI: __CONTACT_CENTER__ ? acceptedConditions && agreementChecked
            : acceptedConditions,
        fieldErrors: __CONTACT_CENTER__ ? !acceptedConditions || !agreementChecked
            : !acceptedConditions
    });
};

const insuranceRequestWizardStep5 = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_WIZARD_VALIDATE_STEP:
        case SHOW_PRINT_REQUIRED:
            return validateStep(state);

        case INSURANCE_REQUEST_WIZARD_SET_VISIBLE_STEP:
            return state.merge({
                valid: false,
                fieldErrors: false
            });

        case INSURANCE_REQUEST_WIZARD_SET_DATA:
            return state.merge({
                ...action.data,
                validUI: false,
                valid: false
            });

        case INSURANCE_REQUEST_GET_DOCUMENT_REQUEST:
            return state.merge({
                documents: {
                    [action.data.docType]: { isFetching: true }
                }
            });

        case INSURANCE_REQUEST_GET_DOCUMENT_SUCCESS:
            return state.merge({
                documents: {
                    [action.data.docType]: { isFetching: false }
                }
            });

        case INSURANCE_REQUEST_GET_DOCUMENT_FAILURE:
            return state.merge({
                documents: {
                    [action.data.docType]: {
                        isFetching: false,
                        error: action.data.error
                    }
                }
            });
        case INSURANCE_REQUEST_LOAD_DOCUMENTS_FOR_PREVIEW:
            return state.merge({
                isFetchingForPreview: action.data.isFetching
            });
        case INSURANCE_REQUEST_DOCUMENT_READ:
            return state.merge({
                documentRead: action.data,
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestWizardStep5;
